import { Reveal, SectionHeading } from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Votre demande",
    text: "Indiquez-nous la montre que vous recherchez : marque, modèle, référence, budget, état souhaité, année, configuration… Chaque détail compte.",
  },
  {
    n: "02",
    title: "Recherche privée",
    text: "BABYLON transmet votre demande à son réseau et recherche le garde-temps correspondant auprès de ses différentes connexions, sur plusieurs marchés.",
  },
  {
    n: "03",
    title: "Proposition",
    text: "Lorsqu'un modèle correspondant est trouvé, vous recevez les informations nécessaires : la montre, son état, son prix et les conditions d'acquisition.",
  },
  {
    n: "04",
    title: "Acquisition",
    text: "Après votre validation, BABYLON organise et accompagne le processus d'acquisition, avec un suivi personnalisé jusqu'à la réception du garde-temps.",
  },
];

export default function Process() {
  return (
    <section id="processus" className="relative py-32 lg:py-48 bg-coal/30" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading
          eyebrow="Comment ça fonctionne"
          title={
            <>
              Un processus simple.
              <br />
              <span className="italic text-gold">Une exigence constante.</span>
            </>
          }
        />

        <div className="mt-16 lg:mt-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/[0.06]">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={0.12 * i} className="bg-obsidian">
              <div className="group h-full p-8 lg:p-10 hover:bg-card transition-colors duration-700" data-testid={`process-step-${s.n}`}>
                <span className="font-display text-5xl lg:text-6xl text-gold/25 group-hover:text-gold/60 transition-colors duration-700">
                  {s.n}
                </span>
                <h3 className="mt-8 font-display text-2xl text-ivory">{s.title}</h3>
                <p className="mt-4 text-sm text-stone2 leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
